<template>
    <svg
        :width="size"
        :height="size"
        viewBox="0 0 16 16"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
    >
        <defs>
            <path
                id="checkoutline"
                d="M8,0 C12.418278,-8.11624501e-16 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 C3.581722,16 5.41083001e-16,12.418278 0,8 C-5.41083001e-16,3.581722 3.581722,8.11624501e-16 8,0 Z M11.4322452,5.38077914 C11.1698413,5.17144568 10.7874226,5.21446779 10.5780891,5.4768717 L10.5780891,5.4768717 L6.98578644,9.97989899 L5.85441559,8.84852814 C5.54199615,8.5361087 5.03546417,8.5361087 4.72304474,8.84852814 C4.4106253,9.16094757 4.4106253,9.66747955 4.72304474,9.97989899 L4.72304474,9.97989899 L6.18875387,11.4456081 C6.21691191,11.4737662 6.24672674,11.5002171 6.2780391,11.5248197 C6.71231073,11.8660331 7.34096557,11.7905945 7.68217899,11.3563229 L7.68217899,11.3563229 L11.5436995,6.4416604 C11.7834095,6.13657498 11.7573375,5.70048327 11.4829856,5.42613132 C11.4669324,5.41007814 11.4499924,5.39493702 11.4322452,5.38077914 Z"
                :stroke="color"
            />
        </defs>
        <g id="Icons_Check" stroke="none" stroke-width="0" fill="none" fill-rule="evenodd">
            <mask id="mask-2" fill="white">
                <use xlink:href="#checkoutline" />
            </mask>
            <use id="Combined-Shape" :fill="color" xlink:href="#checkoutline" />
        </g>
    </svg>
</template>

<script>
import VueTypes from 'vue-types';

export default {
    name: 'CheckOutlineSVG',
    props: {
        size: VueTypes.integer.isRequired,
        color: VueTypes.string.isRequired,
    },
};
</script>

<style></style>
